import ProjetNom from '@/generated/controls/projet/ProjetNom.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ProjetNom
})
